<template>
  <div class="fixed-bottom floating-navbar pt-0">
    <nav class="navbar navbar-light">
      <div class="container-fluid">
        <router-link v-for="item in items" :key="item" :to="{name: item}" class="navbar-brand">
          <SvgIcon :icon="`menu/${item}`"/>
          <span class="text-capitalize-first">{{ $t(item) }}</span>
        </router-link>
      </div>
    </nav>
  </div>
</template>

<script setup lang="ts">
import SvgIcon from "@/components/SvgIcon.vue";
const items = ['home', 'tournaments', 'games', 'store', 'profile']
</script>